import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline/index';
import {withStyles} from '@material-ui/core/styles/index';
import AppBarWidget from './AppBarWidget';
import Grid from '@material-ui/core/Grid';
import RouteContainer from "./RouteContainer";
import {BrowserRouter as Router, NavLink} from "react-router-dom";

const appStyles = theme => ({
        '@global': {
            ul: {
                margin: 0,
                padding: 0,
                listStyle: 'none',
            }
        },
        /*
          Style for the overall app bar at the very top
         */
        appBar: {
            borderBottom: `1px solid ${theme.palette.divider}`,
            background: "linear-gradient(to right, #C9D6FF, #E2E2E2)"
        },
        /*
          Style for the toolbar included within the app bar
         */
        toolbar: {
            flexWrap: 'wrap',
        },
        /*
          Style for the menue items used for navigation
         */
        menuToolbar: {
            flexGrow: 1,
        },
        /*
          Style for the links included in the menu toolbar (inactive)
         */
        menuToolbarLinkInactive: {
            margin: theme.spacing(1, 1.5),
            textDecoration: 'none',
            color: "#6159E5"
        },
        /*
              Style for the links included in the menu toolbar (inactive)
             */
        menuToolbarLinkActive: {
            margin: theme.spacing(1, 1.5),
            textDecoration: 'none',
            fontWeight: "bold",
            color: "#6159E5"
        },
        /*
          Style for placing the header on the get started page
         */
        getStartedContentHeader: {
            padding: theme.spacing(8, 0, 6),
        },
        /*
          Style of the image shown on the onboarding / description screen
         */
        onboardingImage: {
            display: 'flex',
            justifyContent: 'left',
            justifyItems: 'left',
            justifySelf: 'left',
        },
        onboardingStepCounter: {
            color: '#6159E5',
            fontWeight: 'bold',
            fontSize: '40px',
            borderRadius: '50%',
            background: '#2F2E41',
            width: '50px',
            height: '50px',
            textAlign: 'center',
            verticalAlign: 'middle'
        },

        imgbox: {
            display: 'grid',
            height: '100%',
        },
        centerFit: {
            maxWidth: '100%',
            maxHeight: '100vh',
            margin: 'auto'
        },

        /*
          Style of the button to browse through the onboarding images
         */
        onboardingBigButton: {
            backgroundColor: 'transparent',
            borderWidth: '0px',
        },
        onboardingButtonIcon: {
            textAlign: 'center',
            display: 'inline',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            backgroundColor: '#2F2E41'
        },
        /*
          Overall design for the onboarding / description screen
         */
        onboardingScreen: {
            paddingTop: theme.spacing(4),
            marginLeft: theme.spacing(4),
            marginRight: theme.spacing(4),
        },
        /*
          Style for the general card (single card)
         */
        getStartedCard: {
            height: "100%"
        },
        /*
          Style of the card header of a single card
         */
        getStartedCardHeader: {
            backgroundColor:
                theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
        },
        /*
          Style of the card body (i.e. the image shown in the card usually)
         */
        getStartedCardContent: {
            display: 'flex',
            justifyContent: 'center',
        },
        /*
          Style for the overall body screen (i.e. everything except the app bar)
         */
        bodyScreen: {
            background: "linear-gradient(to right, #C9D6FF, #E2E2E2)",
            width: "100%",
            position: "relative",
        },
        application: {
            minHeight: "120vh",
            margin: "0",
            display: "grid",
            gridTemplateRows: "auto 1fr auto",
        },
        footer: {
            background: "#E2E2E2",
            position: "relative",
            borderTop: `2px solid ${theme.palette.divider}`,
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            textAlign: 'center'
        },
        /*
          Style for placing the header on the get support page
         */
        supportContentHeader: {
            padding: theme.spacing(8, 0, 6),
        },
        privacyPolicy: {
            fontSize: 12,
            height: "100vh",
            overflow: "auto",
            padding: "10px",
        },
        legalTextStandard: {
            fontSize: 12
        },
        legalTextBottom: {
            fontSize: 12,
            borderBottom: `2px solid ${theme.palette.divider}`
        }
    })
;

const footers = [
    {
        column: [
            {label: 'Support', link: '/support'},
            {label: 'Privacy Policy', link: '/capture-n-paste-privacy-policy'},
            {label: 'Imprint', link: '/imprint'}
        ]
    }
];

class AppWidget extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        // The classes are taken from the withStyles extension called by the 'default export' (end of the class)
        const {classes} = this.props;

        return (
            <div className={classes.application}>
                <React.Fragment>
                    <Router>
                        <AppBarWidget appStyle={classes}/>
                        <CssBaseline/>

                        <div className={classes.bodyScreen}>
                            <RouteContainer appStyle={classes}/>
                        </div>

                        {/* Footer */}
                        <div className={classes.footer}>
                            <Grid container justify="space-evenly">
                                {footers.map((footer) => (
                                    <ul>
                                        <nav>
                                            {footer.column.map((item) => (
                                                <li key={item}>
                                                    <NavLink className={classes.menuToolbarLinkInactive} to={item.link}>
                                                        {item.label}
                                                    </NavLink>
                                                </li>
                                            ))}
                                        </nav>
                                    </ul>
                                ))}
                            </Grid>
                        </div>
                        {/* End footer */}
                    </Router>
                </React.Fragment>
            </div>
        );
    }
}

export default withStyles(appStyles)(AppWidget);
